/** Extrait les numéros de version depuis un CHANGELOG (titres `## [x.y]`). */
export function parseChangelogVersions(markdown) {
  const versions = [];
  const lines = String(markdown || '').replace(/\r\n/g, '\n').split('\n');
  for (const line of lines) {
    const match = line.trim().match(/^## \[([^\]]+)\]/);
    if (match) versions.push(match[1]);
  }
  return versions;
}

/** Requête de recherche ciblant une version dans le changelog. */
export function versionSearchQuery(version) {
  return `[${version}]`;
}
